module.exports = {"ru":{"zoomInButton":"Увеличить","excelButton":"Загрузить XLS"},"en":{"zoomInButton":"Zoom In","excelButton":"Download XLS"}}


//////////////////
// WEBPACK FOOTER
// ./temp/components/figure-buttons/.variant/base/text.yaml
// module id = 181
// module chunks = 0